<section class="inq-page" dir="rtl">
  <header class="inq-page__head">
    <div>
      <h2><i class="mdi mdi-forum"></i> פניות</h2>
      <p>הודעות בין קונים למוכרים על המודעות — בלי לחשוף מספרי טלפון.</p>
    </div>
  </header>

  <!-- WhatsApp opt-in -->
  @if (consent?.available) {
    <div class="wa-card" [class.wa-card--on]="consent?.opted_in">
      <span class="wa-card__icon"><i class="mdi mdi-whatsapp"></i></span>
      <div class="wa-card__text">
        <strong>{{ consent?.opted_in ? 'פניות ותשובות מגיעות גם לוואטסאפ שלך' : 'קבלו פניות ותשובות ישירות לוואטסאפ' }}</strong>
        <span>ההודעות נשלחות מהמספר העסקי של Sale4ALL. אפשר לענות ישירות מוואטסאפ, והמספר שלכם לא נחשף.</span>
        @if (consentMsg) { <span class="wa-card__ok">{{ consentMsg }}</span> }
        @if (consentErr) { <span class="wa-card__err">{{ consentErr }}</span> }
      </div>
      <div class="wa-card__form">
        @if (!consent?.opted_in) {
          <input type="tel" inputmode="tel" dir="ltr" placeholder="05X-XXXXXXX" [value]="consentPhone"
                 (input)="onConsentPhone($event)" aria-label="מספר וואטסאפ">
          <button type="button" class="btn-wa" (click)="saveConsent(true)" [disabled]="consentSaving">הפעלה</button>
        } @else {
          <span class="wa-card__phone" dir="ltr">{{ consentPhone }}</span>
          <button type="button" class="btn-ghost" (click)="saveConsent(false)" [disabled]="consentSaving">ביטול</button>
        }
      </div>
    </div>
  }

  <div class="inq-layout" [class.inq-layout--thread]="activeId">
    <!-- List -->
    <aside class="inq-list">
      <div class="inq-tabs" role="tablist">
        <button type="button" role="tab" [class.active]="role === 'all'" (click)="setRole('all')">הכל</button>
        <button type="button" role="tab" [class.active]="role === 'selling'" (click)="setRole('selling')">קיבלתי</button>
        <button type="button" role="tab" [class.active]="role === 'buying'" (click)="setRole('buying')">שלחתי</button>
      </div>

      @if (loading) {
        <div class="inq-empty"><span class="spin"></span></div>
      } @else if (failed) {
        <div class="inq-empty">לא הצלחנו לטעון את הפניות. <button type="button" class="link" (click)="loadList()">נסו שוב</button></div>
      } @else if (!items.length) {
        <div class="inq-empty">
          <i class="mdi mdi-inbox"></i>
          <p>אין עדיין פניות.</p>
          <span>כשתשלחו הודעה למוכר, או כשקונה יפנה אליכם — השיחה תופיע כאן.</span>
        </div>
      } @else {
        <ul class="inq-rows">
          @for (it of items; track it.id) {
            <li>
              <button type="button" class="inq-row" [class.active]="it.id === activeId" [class.unread]="it.unread > 0"
                      (click)="open(it)">
                <span class="inq-row__img">
                  @if (it.product.image) { <img [src]="it.product.image" alt="" loading="lazy"> }
                  @else { <i class="mdi mdi-message-text-outline"></i> }
                </span>
                <span class="inq-row__text">
                  <span class="inq-row__top">
                    <strong>{{ it.other.name }}</strong>
                    <time>{{ it.last_message_at | date:'dd/MM HH:mm' }}</time>
                  </span>
                  <span class="inq-row__ad">
                    <span class="role" [class.role--sell]="it.role === 'seller'">{{ it.role === 'seller' ? 'פנייה אליך' : 'פנית' }}</span>
                    {{ it.product.name }}
                  </span>
                  <span class="inq-row__last">
                    @if (it.last_message?.mine) { <span class="me">את/ה: </span> }{{ it.last_message?.text }}
                  </span>
                </span>
                @if (it.unread > 0) { <span class="inq-row__badge">{{ it.unread }}</span> }
              </button>
            </li>
          }
        </ul>
      }
    </aside>

    <!-- Thread -->
    <main class="inq-thread">
      @if (!activeId) {
        <div class="inq-empty inq-empty--big">
          <i class="mdi mdi-forum"></i>
          <p>בחרו שיחה מהרשימה</p>
        </div>
      } @else if (threadLoading && !thread) {
        <div class="inq-empty"><span class="spin"></span></div>
      } @else if (!thread) {
        <div class="inq-empty">{{ error || 'השיחה לא נמצאה' }}</div>
      } @else {
        <div class="thr-head">
          <button type="button" class="thr-back" (click)="back()" aria-label="חזרה לרשימה"><i class="mdi mdi-arrow-right"></i></button>
          <span class="thr-av">
            @if (thread.other.avatar) { <img [src]="thread.other.avatar" alt=""> } @else { {{ initials(thread.other.name) }} }
          </span>
          <div class="thr-who">
            <strong>{{ thread.other.name }}</strong>
            @if (thread.product.id && thread.product.live) {
              <a [routerLink]="['/single', thread.product.id]">{{ thread.product.name }}</a>
            } @else {
              <span>{{ thread.product.name }}{{ thread.product.id ? ' · לא פעילה' : '' }}</span>
            }
          </div>
          @if (thread.other_on_whatsapp) {
            <span class="thr-wa" title="ההודעות שלך מגיעות גם לוואטסאפ של הצד השני"><i class="mdi mdi-whatsapp"></i> וואטסאפ</span>
          }
        </div>

        <div class="thr-msgs" #scroller>
          @for (m of thread.messages; track m.id) {
            <div class="msg" [class.msg--mine]="m.mine">
              <div class="msg__bubble">
                <p>{{ m.text }}</p>
                <span class="msg__meta">
                  @if (m.channel === 'whatsapp') { <i class="mdi mdi-whatsapp" title="נשלח מוואטסאפ"></i> }
                  <time>{{ m.at | date:'dd/MM HH:mm' }}</time>
                  @if (m.mine && ticks(m); as t) { <i class="mdi {{ t.icon }} tick {{ t.cls }}" [title]="t.title"></i> }
                </span>
              </div>
            </div>
          }
        </div>

        <div class="thr-compose">
          @if (error) { <p class="thr-err" role="alert">{{ error }}</p> }
          <div class="thr-compose__row">
            <textarea rows="1" placeholder="כתבו הודעה…" [value]="draft" (input)="onDraft($event)" (keydown)="onKey($event)"
                      [disabled]="sending" aria-label="הודעה"></textarea>
            <button type="button" class="btn-send" (click)="send()" [disabled]="sending || !draft.trim()" aria-label="שליחה">
              <i class="mdi mdi-send"></i>
            </button>
          </div>
        </div>
      }
    </main>
  </div>
</section>
